import * as React from 'react';
import * as injectTapEventPlugin from 'react-tap-event-plugin';

import { Role, StudioAppConfig } from 'glance-datatypes';

import { connect } from 'react-redux';
import { itemsFetchDataSuccess } from '../actions/draftsAction';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import RestService from '../RestService';
import Welcome from './Welcome';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Utils from '../Utils';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

interface Props {
    location?: any;
    history?: any;
    itemsFetchDataSuccess?: (config) => void;
    studioAppConfig?: StudioAppConfig
}

interface State {
    showLogin?: boolean;
    checkingForLogin?: boolean;
    studioAppConf?: StudioAppConfig;
}

const spacing = {
      iconSize: 24,
      desktopGutter: 24,
      desktopGutterMore: 32,
      desktopGutterLess: 8,
      desktopGutterMini: 8,
      desktopKeylineIncrement: 60,  // left-nav width = this * 4
      desktopDropDownMenuItemHeight: 32,
      desktopDropDownMenuFontSize: 15,
      desktopLeftNavMenuItemHeight: 30,
      desktopSubheaderHeight: 48,
      desktopToolbarHeight: 56,
};

const muiTheme = getMuiTheme({
  spacing : spacing,
});


class GlanceStudioApp extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            checkingForLogin: true,
        };
    }

    setUserRole = (config, showLogin) => {
        if (showLogin || this.props.location.pathname.length == 1) {
            switch (config.currentToken.role) {
                case Role.PARTNER:
                    this.props.history.push('/partner');
                    break;
                case Role.ADMIN:
                case Role.MODERATOR:
                    this.props.history.push('/moderator');
                    break;
                case Role.DESIGNER:
                    this.props.history.push('/designer');
                    break;
                case Role.CURATOR:
                    this.props.history.push('/curator');
                    break;
                default:
                    break;
            }
        }
        this.setState({
            ...this.state,
            checkingForLogin: false,
            studioAppConf: config,
        });
    }

    componentDidMount() {
        const isLoggedIn = Utils.getCookieValueByName('glance-studio-session');
        let showLogin: boolean = this.shouldShowLogin();

        let that = this;
        const isConfigFetch = Object.keys(this.props.studioAppConfig.currentToken).length > 0;
        if (isLoggedIn) {
            if (!isConfigFetch) {
                RestService.getStudioAppConfig((config) => {
                this.props.itemsFetchDataSuccess(config);
                    if (!config) {
                        if (!showLogin) {
                            that.props.history.push('/login?redirect=' + this.props.location.pathname);
                            window.location.reload();
                        }
                        that.setState({
                            ...that.state,
                            checkingForLogin: false,
                        });
                    } else {
                        this.setUserRole(config, showLogin);
                    }
                });
            } else {
                const config = this.props.studioAppConfig;
                this.setUserRole(config, showLogin);
            }
        } else {
            this.setState({
                ...this.state,
                checkingForLogin: false,
            });
            that.props.history.push('/login?redirect=' + this.props.location.pathname);
        }
    }

    shouldShowLogin() : boolean {
        const path: string = this.props.location.pathname;
        let showLogin: boolean = false;
        const pathEnd = path.indexOf('/', 1);
        if (path.substr(1, pathEnd == -1 ? path.length - 1 : pathEnd) === 'login') (
            showLogin = true
        );
        return showLogin;
    }

    render() {
        let content;

         if (this.state.checkingForLogin) {
             content = (
                        <Welcome />
             );
         } else {
             content = this.props.children;
         }

        return (
                <MuiThemeProvider muiTheme={muiTheme}>
                {
                    content
                }
                </MuiThemeProvider>
            );
    }
}

const mapStateToProps = (state) => ({
    studioAppConfig: state.studioAppConfig
})

const mapDispatchToProps = (dispatch) => {
return {
    itemsFetchDataSuccess: (config) => dispatch(itemsFetchDataSuccess(config)),
};
};

export default connect(mapStateToProps, mapDispatchToProps)(GlanceStudioApp);



// WEBPACK FOOTER //
// ./src/components/GlanceStudioApp.tsx